import React from 'react';
import { Alert, Button, Space } from 'antd';
import { withRouter } from 'react-router-dom';
import { ensureFirebaseAuth } from '../../firebase/queries';
import Loader from '../loader/loader';

export default function requireAuth(Component) {
  class AuthenticatedComponent extends React.Component {
    state = { authToken: localStorage.getItem('auth_token'), firebaseReady: false, error: null };

    componentDidMount() {
      this.mounted = true;
      if (!this.state.authToken) this.props.history.replace('/login');
      else this.restoreSession();
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    restoreSession = () => {
      this.setState({ error: null });
      ensureFirebaseAuth().then(
        () => this.mounted && this.setState({ firebaseReady: true }),
        error => this.mounted && this.setState({ error: error.message || 'Unable to restore your session.' })
      );
    };

    render() {
      if (!this.state.authToken) return null;
      if (this.state.firebaseReady) return <Component {...this.props} />;
      return <div className="slim-body"><main className="slim-mainpanel">
        {this.state.error ? <div className="map-load-error"><Alert type="error" showIcon message="Unable to restore session" description={this.state.error} action={<Space wrap><Button onClick={this.restoreSession}>Retry</Button><Button onClick={() => this.props.history.replace('/login')}>Sign in</Button></Space>} /></div> : <Loader inline label="Restoring session…" />}
      </main></div>;
    }
  }

  return withRouter(AuthenticatedComponent);
}
